import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './add-justify-journey.css';



class AddJustifyJourney extends React.Component {
    justifys = [
        { label: 'Folga', value: 'DAY_OFF' },
        { label: 'Férias', value: 'VACATION' },
        { label: 'Atestado', value: 'MEDICAL_CERTIFICATE' }
    ]

    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            alert: { msg: '', type: '' },
            loading: false,
            driverName: '',
            just: {
                startDate: "",
                endDate: "",
                driverId: undefined,
                justificationType: null
            }
        }
    }




    componentDidMount() {
        // this.getJustify()
    }

    getJustify = data => {
        this.setState({ loading: true, table: [], deleteJustify: false, alert: { msg: '', type: '' } });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/journey/justification/${this.props.token}`,
            data
        }).then(d => {
            var msg = !d.data.length ? 'Não encontramos dados para os filtros selecionados.' : ''
            console.log(d)
            this.setState({
                loading: false,
                alert: { msg, type: '' }
            })
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({ loading: false })
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };

    changeJustify = val => {
        let just = this.state.just
        if (val === just.justificationType) {
            just.justificationType = ''
        } else {
            just.justificationType = val
        }
        this.setState({ just })
    }

    clearJust = () => {
        this.setState({
            just: {
                driverId: undefined,
                startDate: '',
                endDate: '',
                justificationType: null
            },
            drivers: { options: [], loading: false },
            driverName: ''
        })

    }

    addJustify = data => {
        console.log(data)
        this.setState({ loading: true, })
      

        axios.put(`${url}/v1/telemetria/admin/journey/justification/${this.props.token}`, data)
            .then(d => {
                this.clearJust();
                store.addNotification({ ...this.props.bodyNotify, title: 'Justificativa Adicionada', type: 'success' });
                this.setState({ loading: false, })

            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    }



    renderToolbar = () => {
        return (
            <ToolBar>
                <div style={{ height: '65px' }}>
                </div>

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : (
                    <div className="add-justify-container">

                        <div className="add-justify-item">

                            <div style={{ width: '220px', marginTop: '10px' }}>
                                <label htmlFor="start-date">Inicio</label>
                                <input
                                    id='start-date'
                                    type="date"
                                    className='form-control toolbar-date input-change-color'
                                    onChange={(i) => this.setState({ just: { ...this.state.just, startDate: i.target.value } })}
                                    disabled={this.state.loading}
                                    placeholder='Inicio'
                                    // max={getFDate()}
                                    value={this.state.just.startDate} />
                            </div>

                            <div style={{ width: '220px', marginTop: '10px' }}>

                                <label htmlFor="end-period">Fim</label>
                                <input
                                    id='end-period'
                                    type="date"
                                    className='form-control toolbar-date input-change-color'
                                    onChange={(i) => this.setState({ just: { ...this.state.just, endDate: i.target.value } })}
                                    disabled={this.state.loading || !this.state.just.startDate}
                                    min={this.state.just.startDate}
                                    // max={getFDate()}
                                    value={this.state.just.endDate}
                                />
                            </div>
                        </div>

                        <div className="add-justify-item">

                            <div style={{ width: '220px', marginTop: '10px', }}>
                                <label htmlFor="drivers">Motoristas</label>
                                {/* Select Motoristas */}
                                <Select
                                    inputId='drivers'
                                    isLoading={this.state.drivers.loading}
                                    className='toolbar-select select-change-color'
                                    loadingMessage={i => `Procurando: ${i.inputValue}`}
                                    placeholder="Motorista"
                                    noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                                    options={this.state.drivers.options}
                                    // isMulti
                                    isClearable
                                    defaultInputValue={this.state.driverName}
                                    closeMenuOnSelect={false}
                                    onChange={(i) => {

                                        if (!i) {
                                            this.setState({ just: { ...this.state.just, driverId: [] }, driverName: '' })
                                        }
                                        else {

                                            this.setState({ just: { ...this.state.just, driverId: i.value }, driverName: i.label })
                                        }
                                    }}
                                    onInputChange={(i) => {
                                        if (i.length > 2) {
                                            this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                            axios
                                                .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                                .then(d => {
                                                    let options = [];
                                                    d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                                    this.setState({ drivers: { options, loading: false } });
                                                })
                                                .catch(e => console.log(e.response));
                                        }
                                    }}
                                    isDisabled={this.state.loading}
                                />
                            </div>

                            <div style={{ width: '220px', marginTop: '10px' }}>
                                <label>Justificativa</label>
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '7px' }}>

                                    {this.justifys.map((d, i) => {
                                        return (
                                            <div key={i} style={{ marginRight: '8px' }}>
                                                <input disabled={this.state.loading} type="radio" id={d.value} name="flag" value={d.value} onChange={() => this.changeJustify(d.value)} checked={this.state.just.justificationType === d.value} />
                                                <label htmlFor={d.value} style={{ margin: '1.5px 0 0 3px' }}>{d.label}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>


                        <div className="button-container">
                            <input
                                type="button"
                                value='Adicionar'
                                className='telemetry-button'
                                onClick={() => this.addJustify(this.state.just)}
                                style={{ marginBottom: '20px' }}
                                disabled={
                                    !this.state.just.startDate || 
                                    !this.state.just.endDate || 
                                    !this.state.just.driverId || 
                                    !this.state.just.justificationType || 
                                    this.state.loading}
                            />
                        </div>



                    </div>
                )}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default AddJustifyJourney